import { RpcStreamingWidgetState } from 'widgets/store/rpcStream/WidgetRpcStreamState';
import { ExpertiseStreamState } from './stream/ExpertiseStreamState';
import { ExpertiseComponentState } from './component/ExpertiseComponentState';
import { ExpertiseConfigurationState } from './configuration/ExpertiseConfigurationState';
import { WidgetWithConfigState } from 'widgets/store/configuration/WidgetWithConfigState';
import { WidgetWithComponentState } from 'widgets/store/component/WidgetWithComponentState';

export type ExpertiseWidgetState =
    RpcStreamingWidgetState<ExpertiseStreamState> &
        WidgetWithConfigState<ExpertiseConfigurationState> &
        WidgetWithComponentState<ExpertiseComponentState>;

export interface ExpertiseWidgetsState {
    [widgetId: string]: ExpertiseWidgetState;
}

export const initialExpertiseWidgetsState: ExpertiseWidgetsState = {};
